import ModifyInfo from './ModifyInfo';

export default ModifyInfo;
